// import { getUserInfo } from "@/apis/model/user"
import { getMessage, setMessage } from "@/uilt/cookie";
// uilt  工具函数都写在里面
const userInfo = getMessage("token");

console.log(userInfo)

const state = {
  // 用户基础信息
  userInfo: {
    // id
    userId: getMessage("userInfo")?.userId || "",
    // 名称
    userName: getMessage("userInfo")?.userName || "",
    // 手机号
    phone: getMessage("userInfo")?.phone || "",
  },
  token: {
    token: getMessage("token")?.token || ""
  }
}

// mutations时同步任务的代码，不能在这里发请求
const mutations = {
  SET_USER_INFO: (state, content) => {
    state.userInfo.name = content.userName;
    state.userInfo.phone = content.phone;
    state.userInfo.userId = content.userId;
    state.token.token = content.token;
    // 存储用户信息
    setMessage("userInfo", state.userInfo);
    // 存储token
    setMessage("token", state.token);
  }
}
// actions是异步任务
const actions = {
  getLoginUserInfo(Content, data) {
    // headUrl	头像	string	
    // lastLoginTime	最后登录时间	string	
    // nickname	名称	string	
    // token	token	string	
    // userId	用户Id
    // 每次登录都会走这里，加载当前页面
    Content.commit('SET_USER_INFO', data)
  }
}



export {
  state, mutations, actions
}